import React, { useContext, useState } from "react";
import { set, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import AuthInputText from "../../components/AuthInput";
import { useNavigate } from "react-router-dom";
import { TokenContext } from "../../service/context/tokencontent";
import CustomModal from "../../components/Modal";
import { AUTH_URL } from "../../common/common";
import { validationSchema } from "../../service/validation/driverKYC";
import { ApiService } from "../../service/api.service";

const DriverKYC = () => {
  const { setToken, token } = useContext(TokenContext)!;
  const [isModalOpen, setModalOpen] = useState(false);
  const apiService = new ApiService();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      // vehicle_number: "",
      licence_number: "",
    },
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const openModal = () => setModalOpen(true);



  const onSubmit = async (data: any) => {
    try {
      // Simulate an API call with a delay
      let newData = {
        type: "Driver",
        licenceNumber: data.licence_number,
      }
      const response = await apiService.postApi(`${AUTH_URL}/business/verify-route`, newData)

      if (response.status === "200") {
        localStorage.setItem("licence-moto", data.licence_number)
        navigate("/verified/driver-kyc")
      }
    } catch (error: any) {
      console.error("Verification Error:", error);
      // Display user-friendly error message
      alert(error.message || "Failed to verify Licence or Vehicle Number. Please try again.");
    }
  };

  //   const vehicleNumber = watch("vehicle_number", ""); // Watch for email value
  const licenceNumber = watch("licence_number", ""); // Watch for email value

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        {/* <div className="bg-[#D9D9D9] rounded-[21.25px] w-full h-full"></div> */}
        <div className="w-full h-full">
          <div className="md:mx-[8rem] my-[2rem] m-6">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <br />
            <p className="font-[700] text-[20px] font-poppins track-[1%]">
              Welcome aboard  👋
            </p>
            <p className="font-[400] font-poppins text-[14px] track-[1%] text-[#313957]">
              Driver KYC
            </p>
            <br />
            {/* Form */}
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <AuthInputText
                label="Vehicle Number"
                value={vehicleNumber}
                errors={errors}
                placeholder="Enter Vehicle Number"
                autoComplete="one-time-code"
                name="vehicle_number"
                type="text"
                // maxLength={6}
                register={register}
              /> */}
              <AuthInputText
                label="Licence Number"
                value={licenceNumber}
                errors={errors}
                placeholder="Enter Licence Number"
                autoComplete="one-time-code"
                name="licence_number"
                type="text"
                // maxLength={6}
                toUpperCase={true}
                register={register}
              />

              {/* Submit button */}
              <div className="flex items-center justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="mt-4 p-2 w-[245px] h-[40px] font-[400] text-[16px] leading-[22.96px] tracking-[1%] bg-[#444FBD] rounded-[20px] text-white rounded"
                >
                  {isSubmitting ? "Verifying..." : "Verify"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </AuthContainer>
  );
};

export default DriverKYC;
